import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import LocationOnTwoToneIcon from "@mui/icons-material/LocationOnTwoTone";

const AddressCard = ({totalCount,cardCss,languageWords}) => {
  const theme = useTheme();
  const { widgetConfig } = useSelector((store) => store?.widgetSettings);
  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: cardCss?.CardSectionBgClr,
        borderRadius: '8px',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        p: 3,
        mt: 2,
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: '0px 6px 14px rgba(0, 0, 0, 0.15)',
        },
       
      }}
    >
      {/* Reservation Text */}
      {totalCount >= widgetConfig?.reservationRequestMin && (
        <Typography
          sx={{
            color: cardCss?.CardSectionHeadingClr,
            fontSize: { md: "18px", sm: "16px", xs: "14px" },
            fontWeight: "bold",
            mb: 1,
          }}
        >
          {languageWords?.reservationGroupText}
        </Typography>
      )}

      {/* Company Name */}
      <Typography
        sx={{
          color: cardCss?.
          CardSectionInfoClr,
          fontWeight: "bold",
          fontSize: { md: "24px", sm: "20px", xs: "18px" },
          
        }}
      >
        {widgetConfig?.company?.company}
      </Typography>

      {/* Address Section */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
        //  backgroundColor: theme?.details?.detailsBgColor,
          padding: "10px",
          borderRadius: "8px",
        }}
      >
        <LocationOnTwoToneIcon
          sx={{
            color:cardCss?.cardSectionIconClr ?? theme?.details?.detailsDateIconColor,
            fontSize: "24px",
          }}
        />
        <Typography
          sx={{
            color: cardCss?.
            CardSectionInfoClr,
            fontSize: "14px",
            //fontWeight: "600",
          }}
        >
          {widgetConfig?.company?.address}, {widgetConfig?.company?.zipcode}, {widgetConfig?.company?.city}
        </Typography>
      </Box>
    </Box>
  );
};

export default AddressCard;



